import { key } from '@connect-x-app/shared-test-ids';

export const APP_CONFIG_TEST_IDS = {
  about: {
    configuration: (label: string) => `appConfig.about.text.${key(label)}`,
    deviceId: 'appConfig.about.button.deviceId',
    licenseItem: (name: string) => `appConfig.about.view.licenseItem.${key(name)}`,
    licenses: 'appConfig.about.scrollView.licenses',
    repository: 'appConfig.about.button.repository',
  },
  profile: {
    about: 'appConfig.profile.button.about',
    back: 'appConfig.profile.button.back',
    close: 'appConfig.profile.button.close',
    email: 'appConfig.profile.text.email',
    jobTitle: 'appConfig.profile.text.jobTitle',
    logout: 'appConfig.profile.button.logout',
    logoutConfirmation: 'appConfig.profile.modal.logoutConfirmation',
    phoneNumber: 'appConfig.profile.text.phoneNumber',
    screen: 'appConfig.profile.modal.screen',
    settings: 'appConfig.profile.button.settings',
  },
  settings: {
    allowPushNotifications: 'appConfig.settings.switch.allowPushNotifications',
    allowPushNotificationsRow: 'appConfig.settings.view.allowPushNotifications',
    group: (group: string) => `appConfig.settings.button.group.${key(group)}`,
    itemToggle: (name: string) => `appConfig.settings.switch.${key(name)}`,
    pushNotifications: 'appConfig.settings.view.pushNotifications',
    setting: (name: string) => `appConfig.settings.view.${key(name)}`,
  },
} as const;
